<template>
    <!--  -->
    <div>
        <!--  -->
        <div>
            <!--  -->
            <div class="flex items-center justify-center px-5 py-5" style="background-color: #f9f7fd">
                <!--  -->
                <div class="w-full mx-auto h-auto rounded-xlshadow-sm p-10 text-gray-800 relative overflow-hidden bg-white" style="box-shadow: 0 25px 50px rgb(8 21 66 / 4%)">
                    <!--  -->
                    <div class="relative filter-tel teleconsultant">
                        <!--  -->
                        <div class="grid grid-cols-4 gap-4">
                            <!--  -->
                            <v-select v-if="currentUser.type && currentUser.type != 'TeleConsultant'" @search="getUsersDebance($event, 'TeleConsultant')" label="fullName" :options="TabTeleConsultant" class="input-style" v-model="formData.teleConsultant" :placeholder="$t('Select TeleConsultant')" @input="setSelected"></v-select>
                            <!--  -->

                            <!--  -->
                            <select id="type" name="date" autocomplete="type" v-model="duree" @change="ChangeTypeDate($event)" class="input-style">
                                <!--  -->
                                <option value="Today">{{ $t('today') }}</option>
                                <!--  -->
                                <option value="Yesterday">{{ $t('yesterday') }}</option>
                                <!--  -->
                                <option value="This Month">{{ $t('this_month') }}</option>
                                <!--  -->
                                <option value="Last Month">{{ $t('last_month') }}</option>
                                <!--  -->
                                <option value="This Year">{{ $t('this_year') }}</option>
                                <!--  -->
                                <option value="Last Year">{{ $t('last_year') }}</option>
                                <!--  -->
                            </select>
                            <!--  -->

                            <!--  -->
                            <input :placeholder="$t('star_date')" onfocus="(this.type='date')" v-model="formData.startDate" class="input-style" />
                            <!--  -->

                            <!--  -->
                            <input class="input-style" :placeholder="$t('end_date')" onfocus="(this.type='date')" v-model="formData.endDate" />
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="grid grid-cols-3 gap-4 mt-4">
                            <!--  -->
                            <v-select @search="getUsersDebance($event, 'Seller')" @input="CheckSellerProducts($event, 'seller')" label="company" :placeholder="$t('company')" :options="sellers" v-model="sellerdata" class="input-style"></v-select>

                            <!--  -->
                            <v-select @search="getProducts($event, 'storeino')" @input="CheckSellerProducts($event, 'product')" label="name" placeholder="Product name ..." :options="products" :disabled="!sellerdata" v-model="productdata" class="input-style"></v-select>
                            <!--  -->

                            <div class="flex">
                                <!--  -->
                                <v-select placeholder="Upsel ..." :options="['oui', 'non']" v-model="upsel" class="input-style w-1/2"></v-select>
                                <!--  -->

                                <!--  -->
                                <button type="button" @click="getTotalStatusPerTeleconsultantBetweenTwoDate" class="border w-full ml-4 font-semiborder-indigo-500 bg-indigo-500 text-white rounded-md transition duration-500 ease select-none hover:bg-indigo-600 focus:outline-none focus:shadow-outline">
                                    {{ $t('apply') }}
                                </button>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="absolute top-0 left-0 w-full h-2 flex">
                        <!--  -->
                        <div class="h-1 bg-primary-600 flex-1"></div>
                        <!--  -->
                        <div class="h-1 bg-yellow-500 flex-1"></div>
                        <!--  -->
                        <div class="h-1 bg-primary-600 flex-1"></div>
                        <!--  -->
                        <div class="h-1 bg-yellow-500 flex-1"></div>
                        <!--  -->
                        <div class="h-1 bg-primary-600 flex-1"></div>
                        <!--  -->
                        <div class="h-1 bg-yellow-500 flex-1"></div>
                        <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full">
                        <!--  -->
                        <div class="antialiased mt-8">
                            <!--  -->
                            <div class="items-center">
                                <!--  -->
                                <div class="grid grid-flow-col gap-6">
                                    <!--  -->
                                    <div class="card relative">
                                        <!--  -->
                                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                        <!--  -->
                                        <div class="card-body">
                                            <!--  -->
                                            <div class="d-flex">
                                                <!--  -->
                                                <div class="">
                                                    <!--  -->
                                                    <h6 class="font-semibold">Taux de confirmation</h6>
                                                    <!--  -->
                                                    <h1 class="mt-2 mb-3 display-6 font-weight-bold text-dark">
                                                        <!--  -->
                                                        {{ getPercentege(null, countOrderConf, countOrderConf + countOrderCan + countOrderPendingUnr + countOrderToRem, null)}}%
                                                        <!--  -->
                                                    </h1>
                                                    <!--  -->
                                                </div>
                                                <!--  -->

                                                <!--  -->
                                                <div class="ml-auto">
                                                    <!--  -->
                                                    <div class="feature">
                                                        <!--  -->
                                                        <div class="fa-stack fa-lg fa-2x icon bg-primary">
                                                            <!--  -->
                                                            <img src="https://img.icons8.com/external-nawicon-glyph-nawicon/64/FFFFFF/external-call-center-communication-nawicon-glyph-nawicon.png" />
                                                            <!--  -->
                                                        </div>
                                                        <!--  -->
                                                    </div>
                                                    <!--  -->
                                                </div>
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->

                                        <!--  -->
                                        <div class="card-footer">
                                            <!--  -->
                                            <div>
                                                <!--  -->
                                                <span class="text-left">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/verified-account.png" />
                                                    <!--  -->
                                                    <span class="text-success">
                                                        <!--  -->
                                                        CONFIRMED (<b>{{ countOrderConf }}</b>)
                                                        <!--  -->
                                                    </span>
                                                    <!--  -->
                                                </span>
                                                <!--  -->

                                                <!--  -->
                                                <span class="float-right">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/material-rounded/24/000000/refresh.png" />
                                                    <!--  -->

                                                    <!--  -->
                                                    <span style="color: #d616d4">
                                                        <!--  -->
                                                        PENDING UNREACHED (<b>{{ countOrderPendingUnr }}</b>)
                                                        <!--  -->
                                                    </span>
                                                    <!--  -->
                                                </span>
                                                <!--  -->
                                            </div>

                                            <!--  -->
                                            <div>
                                                <!--  -->
                                                <span class="text-left">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/delete-ticket.png" />
                                                    <!--  -->

                                                    <!--  -->
                                                    <span class="text-danger">
                                                        <!--  -->
                                                        CANCELLED (<b>{{ countOrderCan }}</b>)
                                                        <!--  -->
                                                    </span>
                                                    <!--  -->
                                                </span>
                                                <!--  -->

                                                <!--  -->
                                                <span class="float-right">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/material-outlined/24/000000/internal-call.png" />
                                                    <!--  -->

                                                    <!--  -->
                                                    <span style="color: #af7704">
                                                        <!--  -->
                                                        TO REMIND (<b>{{ countOrderToRem }}</b>)
                                                        <!--  -->
                                                    </span>
                                                    <!--  -->
                                                </span>
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->
                                    </div>
                                    <!--  -->

                                    <!--  -->
                                    <div class="card relative">
                                        <!--  -->
                                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                        <!--  -->
                                        <div class="card-body">
                                            <!--  -->
                                            <div class="d-flex">
                                                <!--  -->
                                                <div class="">
                                                    <!--  -->
                                                    <h6 class="font-semibold">Taux de livraison</h6>
                                                    <!--  -->
                                                    <h1 class="mt-2 mb-3 display-6 font-weight-bold text-dark">
                                                        <!--  -->
                                                        {{ getPercentege(null, countOrderDelivred, countOrderConf, null) }}%
                                                        <!--  -->
                                                    </h1>
                                                    <!--  -->
                                                </div>
                                                <!--  -->

                                                <!--  -->
                                                <div class="ml-auto">
                                                    <!--  -->
                                                    <div class="feature">
                                                        <!--  -->
                                                        <div class="fa-stack fa-lg fa-2x icon bg-primary">
                                                            <!--  -->
                                                            <img src="https://img.icons8.com/glyph-neue/64/FFFFFF/in-transit.png" />
                                                            <!--  -->
                                                        </div>
                                                        <!--  -->
                                                    </div>
                                                    <!--  -->
                                                </div>
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>

                                        <!--  -->
                                        <div class="card-footer">
                                            <!--  -->
                                            <div>
                                                <!--  -->
                                                <span class="text-left">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/treatment-list.png" />
                                                    <!--  -->
                                                    TRAITS
                                                    <!--  -->
                                                </span>
                                                <!--  -->

                                                <!--  -->
                                                <span class="float-right">
                                                    <!--  -->
                                                    (<b>{{ countOrderConf }}</b>)
                                                    <!--  -->
                                                </span>
                                                <!--  -->
                                            </div>
                                            <!--  -->

                                            <!--  -->
                                            <div>
                                                <!--  -->
                                                <span class="text-left">
                                                    <!--  -->
                                                    <img class="img-call" src="https://img.icons8.com/ios-glyphs/30/000000/shipped--v1.png" />
                                                    <!--  -->

                                                    <!--  -->
                                                    <span class="text-success"> DELIVRED </span>
                                                    <!--  -->
                                                </span>
                                                <!--  -->

                                                <!--  -->
                                                <span class="float-right text-success">
                                                    <!--  -->
                                                    (<b>{{ countOrderDelivred }}</b>)
                                                    <!--  -->
                                                </span>
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->
                                    </div>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->

                            <!--  -->
                            <div class="h-20 flex items-center">
                                <!--  -->
                                <div class="text-xl font-bold text-primary-700 mr-5">
                                    <!--  -->
                                    {{ $t('teleconsultant') }} analytics
                                    <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div :class="{ 'cursor-not-allowed pointer-events-none': TeleConsultantTab.length == 0, }" @click="downloadAnalytics" class="ml-auto cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 p-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300">
                                    <!--  -->
                                    <i class="material-icons">file_download</i> csv
                                    <!--  -->
                                </div>
                            </div>
                            <!--  -->

                            <!--  -->
                            <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 overflow-x-auto">
                                <!--  -->
                                <div class="inline-block min-w-full rounded-lg overflow-hidden relative">
                                    <!--  -->
                                    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                    <!--  -->

                                    <!--  -->
                                    <div class="table-responsive custom-table-responsive">
                                        <!--  -->
                                        <table class="table custom-table">
                                            <!--  -->
                                            <thead>
                                                <!--  -->
                                                <tr>
                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-left">
                                                        <!--  -->
                                                        {{ $t('user') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('Confirmation rate') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('delivry rate') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('traits') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('confirmed') }}
                                                        <!--  -->
                                                    </th>

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('delivred') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('cancelled') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('Pending Unreached') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('to_remind') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('Unreached') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('reprogram') }}
                                                        <!--  -->
                                                    </th>

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('interested') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('calls') }}
                                                        <!--  -->
                                                        (<i class="material-icons" style="font-size: 17px; vertical-align: bottom">local_phone</i>)
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->

                                                    <!--  -->
                                                    <th scope="col" class="uppercase text-center">
                                                        <!--  -->
                                                        {{ $t('action') }}
                                                        <!--  -->
                                                    </th>
                                                    <!--  -->
                                                </tr>
                                                <!--  -->
                                            </thead>
                                            <!--  -->

                                            <!--  -->
                                            <tbody>
                                                <!--  -->
                                                <tr v-for="(item, index) in TeleConsultantTab" :key="index" scope="row">
                                                    <!--  -->
                                                    <td class="border-t-b-l">
                                                        <!--  -->
                                                        <div class="box flex items-center zoom-in">
                                                            <!--  -->
                                                            <div class="w-10 h-10 flex-none image-fit rounded-full overflow-hidden">
                                                                <!--  -->
                                                                <a :class="'bg-' + getBgColor()" class="btn btn-circle btn-danger text-white uppercase">
                                                                    <!--  -->
                                                                    {{ nameToInitials(  DataParse(item.userData).fullName ) }}
                                                                    <!--  -->
                                                                </a>
                                                                <!--  -->
                                                            </div>

                                                            <!--  -->
                                                            <div v-if="DataParse(item.userData).fullName" class="ml-3">
                                                                <!--  -->
                                                                <div class="font-medium">
                                                                    <!--  -->
                                                                    {{ DataParse(item.userData).fullName }}
                                                                    <!--  -->
                                                                </div>
                                                                <!--  -->

                                                                <!--  -->
                                                                <div class="text-gray-600 text-xs mt-0.5">
                                                                    <!--  -->
                                                                    {{ DataParse(item.userData).type }}
                                                                    <!--  -->
                                                                </div>
                                                                <!--  -->
                                                            </div>
                                                            <!--  -->

                                                            <!--  -->
                                                            <div v-else class="lds-ellipsis">
                                                                <!--  -->
                                                                <div></div>
                                                                <!--  -->
                                                                <div></div>
                                                                <!--  -->
                                                                <div></div>
                                                                <!--  -->
                                                                <div></div>
                                                                <!--  -->
                                                            </div>
                                                            <!--  -->
                                                        </div>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b-l">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Confirmed')" :radius="25" :strokeWidth="8" :value="getPercentege( null, item.confirmed, item.countAll, null)"></Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b-r">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Delivered')" :radius="25" :strokeWidth="8" :value="getPercentege(null, item.delivred, item.confirmed, null)"></Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b-r">
                                                        <!--  -->
                                                        {{ item.countAll }}
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td v-for="(it, indx) in item.status" :key="indx" class="text-center" :class="it.name == 'Delivered' || it.name == 'Unreached' ? 'border border-black' : 'border-t-b'">
                                                        <!--  -->
                                                        <span class="text-gray-900 rounded-full">
                                                            <!--  -->
                                                            <Progress :strokeColor="getColor(it.name)" :radius="30" :strokeWidth="8" :value="getPercentege(it.name, it.count, item.countAll, item.callAll, item.confirmed)">
                                                                <!--  -->
                                                                <template v-slot:footer>
                                                                    <!--  -->
                                                                    <span class="flex flex-col fz-12">
                                                                        <!--  -->
                                                                        <span class="text-gray-900">{{ $t('total') }}: {{ it.count }}</span>
                                                                        <!--  -->
                                                                        <span class="upsells ml-1" v-if="it.upsells">
                                                                            (<b><span class="mr-1">🛍️</span> Up-Sells: {{ it.upsells }}</b>)
                                                                        </span>
                                                                    </span>
                                                                    <!--  -->
                                                                </template>
                                                                <!--  -->
                                
                                                            </Progress>
                                                            <!--  -->
                                                        </span>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b-r">
                                                        <!--  -->
                                                        <p class="text-gray-900 whitespace-no-wrap font-bold">
                                                            <!--  -->
                                                            {{ item.callAll }}
                                                            <!--  -->
                                                        </p>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="border border-t-b-r text-center">
                                                        <!--  -->
                                                        <a href="#" class="text-primary-400 hover:text-primary-700 underline" @click="Detials(item)">
                                                            <!--  -->
                                                            <i class="material-icons mx-1">remove_red_eye</i>
                                                            <!--  -->
                                                        </a>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->
                                                </tr>
                                                <!--  -->

                                                <!--  -->
                                                <tr class="spacer">
                                                    <!--  -->
                                                    <td colspan="100"></td>
                                                    <!--  -->
                                                </tr>
                                                <!--  -->

                                                <!--  -->
                                                <tr v-if="TeleConsultantTab.length > 0">
                                                    <!--  -->
                                                    <td class="border-t-b-l">{{ $t('total') }} :</td>
                                                    <!--  -->
                                                    <td class="text-center border-t-b"></td>
                                                    <!--  -->
                                                    <td class="text-center border-t-b"></td>
                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        {{ countOrderCancAndConf }}
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Confirmed')" :radius="30" :strokeWidth="8" :value="getPercentege(null, countOrderConf, countOrderConf + countOrderCan + countOrderPendingUnr + countOrderToRem, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderConf }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Delivered')" :radius="30" :strokeWidth="8" :value="getPercentege(null, countOrderDelivred, countOrderConf, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderDelivred }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Cancelled')" :radius="30" :strokeWidth="8" :value="getPercentege( null, countOrderCan, countOrderConf + countOrderCan + countOrderPendingUnr + countOrderToRem, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderCan }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Pending Unreached')" :radius="30" :strokeWidth="8" :value="getPercentege( null, countOrderPendingUnr, countOrderConf + countOrderCan + countOrderPendingUnr + countOrderToRem, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderPendingUnr }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('ToRemind')" :radius="30" :strokeWidth="8" :value="getPercentege(null, countOrderToRem, countOrderConf + countOrderCan + countOrderPendingUnr + countOrderToRem, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderToRem }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Unreached')" :radius="30" :strokeWidth="8" :value="getPercentege(null, countOrderUnr, countOrder, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderUnr }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Reprogram')" :radius="30" :strokeWidth="8" :value="getPercentege(null, countOrderReprogram, countOrderConf, null)">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderReprogram }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        <Progress :strokeColor="getColor('Interested')" :radius="30" :strokeWidth="8" :value="getPercentege( null, countOrderInterested, countOrderConf, null, ) ">
                                                            <!--  -->
                                                            <template v-slot:footer>
                                                                <!--  -->
                                                                {{ countOrderInterested }}
                                                                <!--  -->
                                                            </template>
                                                            <!--  -->
                                                        </Progress>
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="text-center border-t-b">
                                                        <!--  -->
                                                        {{ countOrder }}
                                                        <!--  -->
                                                    </td>
                                                    <!--  -->

                                                    <!--  -->
                                                    <td class="border-t-b-r"></td>
                                                    <!--  -->
                                                </tr>
                                                <!--  -->
                                            </tbody>
                                            <!--  -->
                                        </table>
                                        <!--  -->
                                    </div>
                                    <!--  -->

                                    <!--  -->
                                    <div v-if="TeleConsultantTab.length <= 0" class="bg-orange-100 py-8">
                                        <!--  -->
                                        <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                            <!--  -->
                                            <p class="font-semibold flex text-primary-500 whitespace-no-wrap">
                                                <!--  -->
                                                <i class="material-icons mx-3">error</i>
                                                <!--  -->
                                                <span class>No data found</span>
                                                <!--  -->
                                            </p>
                                            <!--  -->
                                        </span>
                                        <!--  -->
                                    </div>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->
                    </div>
                    <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <vue-modal-2 name="ModalInfoTeleconsulatant" :headerOptions="{ title: `TeleConsultant: ${infoTeleconsultant.user.name}` }" :noFooter="true" modalSize="xl" @on-close="close()">
            <!--  -->
            <div class="w-full bg-white rounded-lg p-4 pt-0">
                <!--  -->
                <div class="items-center">
                    <!--  -->
                    <div class="grid grid-flow-col gap-6">
                        <!--  -->
                        <div class="card relative">
                            <!--  -->
                            <div class="card-body">
                                <!--  -->
                                <div class="d-flex">
                                    <!--  -->
                                    <div class="">
                                        <!--  -->
                                        <h6 class="font-semibold">Taux de confirmation</h6>
                                        <!--  -->

                                        <!--  -->
                                        <h1 class="mt-2 mb-3 display-6 font-weight-bold text-dark">
                                            <!--  -->
                                            {{ getPercentege(null, infoTeleconsultant.confirmed, infoTeleconsultant.traits, null) }}%
                                            <!--  -->
                                        </h1>
                                        <!--  -->
                                    </div>
                                    <!--  -->

                                    <!--  -->
                                    <div class="ml-auto">
                                        <!--  -->
                                        <div class="feature">
                                            <!--  -->
                                            <div class="fa-stack fa-lg fa-2x icon bg-primary">
                                                <!--  -->
                                                <img src="https://img.icons8.com/external-nawicon-glyph-nawicon/64/FFFFFF/external-call-center-communication-nawicon-glyph-nawicon.png" />
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->
                                    </div>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->

                            <!--  -->
                            <div class="card-footer">
                                <!--  -->
                                <div>
                                    <!--  -->
                                    <span class="text-left">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/verified-account.png" />
                                        <!--  -->

                                        <!--  -->
                                        <span class="text-success">
                                            <!--  -->
                                            CONFIRMED (<b>{{ infoTeleconsultant.confirmed }}</b>)
                                            <!--  -->
                                        </span>
                                        <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span class="float-right">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/material-rounded/24/000000/refresh.png" />
                                        <!--  -->

                                        <!--  -->
                                        <span style="color: #d616d4">
                                            <!--  -->
                                            PENDING UNREACHED (<b>{{ infoTeleconsultant.pending_unrached }}</b>)
                                            <!--  -->
                                        </span>
                                        <!--  -->
                                    </span>
                                    <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div>
                                    <!--  -->
                                    <span class="text-left">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/delete-ticket.png" />
                                        <!--  -->

                                        <!--  -->
                                        <span class="text-danger">
                                            <!--  -->
                                            CANCELLED (<b>{{ infoTeleconsultant.cancelled }}</b>)
                                            <!--  -->
                                        </span>
                                        <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span class="float-right">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/material-outlined/24/000000/internal-call.png" />
                                        <!--  -->

                                        <!--  -->
                                        <span style="color: #af7704">
                                            <!--  -->
                                            TO REMIND (<b>{{ infoTeleconsultant.toRemind }}</b>)
                                            <!--  -->
                                        </span>
                                        <!--  -->
                                    </span>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="card relative">
                            <!--  -->
                            <div class="card-body">
                                <!--  -->
                                <div class="d-flex">
                                    <!--  -->
                                    <div class="">
                                        <!--  -->
                                        <h6 class="font-semibold">Taux de livraison</h6>
                                        <!--  -->

                                        <!--  -->
                                        <h1 class="mt-2 mb-3 display-6 font-weight-bold text-dark">
                                            <!--  -->
                                            {{ getPercentege(null, infoTeleconsultant.delivred, infoTeleconsultant.confirmed, null) }} %
                                            <!--  -->
                                        </h1>
                                        <!--  -->
                                    </div>
                                    <!--  -->

                                    <!--  -->
                                    <div class="ml-auto">
                                        <!--  -->
                                        <div class="feature">
                                            <!--  -->
                                            <div class="fa-stack fa-lg fa-2x icon bg-primary">
                                                <!--  -->
                                                <img src="https://img.icons8.com/glyph-neue/64/FFFFFF/in-transit.png" />
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->
                                    </div>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->

                            <!--  -->
                            <div class="card-footer">
                                <!--  -->
                                <div>
                                    <!--  -->
                                    <span class="text-left">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/ios-filled/50/000000/treatment-list.png" />
                                        <!--  -->
                                        TRAITS
                                        <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span class="float-right">
                                        <!--  -->
                                        (<b>{{ infoTeleconsultant.confirmed }}</b>)
                                        <!--  -->
                                    </span>
                                    <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div>
                                    <!--  -->
                                    <span class="text-left">
                                        <!--  -->
                                        <img class="img-call" src="https://img.icons8.com/ios-glyphs/30/000000/shipped--v1.png" />
                                        <!--  -->
                                        <span class="text-success"> DELIVRED </span>
                                        <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span class="float-right text-success">
                                        <!--  -->
                                        (<b>{{ infoTeleconsultant.delivred }}</b>)
                                        <!--  -->
                                    </span>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->
                    </div>
                    <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full flex justify-end space-x-4 mr-4">
                    <!--  -->
                    <div @click="downloadAnalytics('Post')" class="ml-auto cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 p-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300 loidingconfirm relative">
                        <!--  -->
                        <loading :active.sync="dataExcel.loading" :is-full-page="fullPage"></loading>
                        <!--  -->
                        <i style="vertical-align: sub;" class="align-sub material-icons">file_download</i>
                        <!--  -->

                        <!--  -->
                        <span v-if="dataExcel.loading" class="inline-block loading-excel">
                            <!--  -->
                            Exporting ({{ timer }}/ {{ paginate.total }})
                            <!--  -->
                            <span>.</span>
                            <!--  -->
                            <span>.</span>
                            <!--  -->
                            <span>.</span>
                            <!--  -->
                        </span>
                        <!--  -->
                        <span v-else>Excel</span>
                        <!--  -->
                    </div>
                    <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div-table :config="configList" :data="infoTeleconsultant.dataOrders" :loading="infoTeleconsultant.loading" :paginate="paginate" @paginatation="paginatation" @refresh="refresh"></div-table>
                <!--  -->
            </div>
            <!--  -->
        </vue-modal-2>
        <!--  -->
    </div>
    <!--  -->
</template>
<!--  -->

<!--  -->
<script>
import HeaderFilters from '@/components/Analytics/Cards/HeaderFilters.vue';
import chartCallcenter from '@/components/Analytics/Cards/chartCallcenter.vue';
import config from './configStatus';

export default {
    components: {
        HeaderFilters,
        chartCallcenter,
    },
    data() {
        return {
            configList: config.list,
            formData: {
                teleConsultant: '',
                startDate: '',
                endDate: '',
            },
            paginate: {
                total: 0,
                currentpage: 1,
                lastpage: 1,
                per_page: 0,
            },
            infoTeleconsultant: {
                user: { name: '', id: null },
                dataOrders: [],
                loading: false,
                confirmed: 0,
                cancelled: 0,
                pending_unrached: 0,
                toRemind: 0,
                delivred: 0,
            },
            duree: 'Today',
            TeleConsultantTab: [],
            teleconsultant: '',
            teleconsultantId: '',
            TabTeleConsultant: [],
            loading: false,
            fullPage: false,
            countOrder: 0,
            countOrderConf: 0,
            countOrderCan: 0,
            countOrderUnr: 0,
            countOrderPendingUnr: 0,
            countOrderToRem: 0,
            countOrderDelivred: 0,
            countOrderReprogram: 0,
            countOrderInterested: 0,
            countOrderCancAndConf: 0,
            idWharhouse: null,
            sellers: [],
            products: [],
            productdata: null,
            upsel: null,
            sellerdata: null,
            sellerSelected: null,
            dataExcel: { loading: false, data: [] },
            timer: 0,
            currentUser: {
                role: {},
            },
        };
    },
    async mounted() {
        await this.getUser();
        if (
            this.currentUser &&
            this.currentUser.type &&
            this.currentUser.type == 'Seller'
        ) {
            this.$router.back();
        }
        await this.getwharhouseId();
        await this.getUsers();
        this.duree = 'Today';
        if (this.teleconsultantId) {
            await this.getTotalOrdersPerTeleConsultant({
                IntervaleDate: 'Today',
                _id: this.teleconsultantId,
            });
        } else {
            await this.getTotalOrdersPerTeleConsultant({
                IntervaleDate: 'Today',
            });
        }
        this.emptyCount();
        await this.getTotal();
        await this.getSellers();
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters['wharhouse/warhouseSelected'];
        },
        currentScrollY() {
            return this.$store.getters['currentScrollY'];
        },
    },
    watch: {
        warhouseSelected: async function (oldVal, newVal) {
            this.TeleConsultantTab = [];
            await this.getwharhouseId();
            await this.getUsers();
            if (this.teleconsultantId) {
                await this.getTotalOrdersPerTeleConsultant({
                    IntervaleDate: this.duree,
                    _id: this.teleconsultantId,
                });
            } else {
                await this.getTotalOrdersPerTeleConsultant({
                    IntervaleDate: this.duree,
                });
            }
            await this.getSellers();
        },
        teleconsultantId: async function (newVal, oldVal) {
            await this.getTotalStatusPerTeleconsultant({
                _id: this.teleconsultantId,
                IntervaleDate: this.duree,
            });
        },
        startDate: async function (newVal, oldVal) { },
        currentScrollY(val) {
            if (val > 222) {
                $('.nav').addClass('sticky');
            } else {
                $('.nav').removeClass('sticky');
            }
        },
    },
    methods: {
        close() {
            this.$vm2.close('ModalInfoTeleconsulatant');
        },
        refresh() { },
        async Detials(data) {
            this.infoTeleconsultant.user.name = this.DataParse(
                data.userData,
            ).fullName;

            this.infoTeleconsultant.user.id = data.user;
            this.infoTeleconsultant.confirmed = data.status.find(
                o => o.name === 'Confirmed',
            ).count;

            this.infoTeleconsultant.cancelled = data.status.find(
                o => o.name === 'Cancelled',
            ).count;

            this.infoTeleconsultant.pending_unrached = data.status.find(
                o => o.name === 'Pending Unreached',
            ).count;

            this.infoTeleconsultant.toRemind = data.status.find(
                o => o.name === 'ToRemind',
            ).count;

            this.infoTeleconsultant.traits = data.countAll;
            this.infoTeleconsultant.delivred = data.status.find(
                o => o.name === 'Delivered',
            ).count;

            this.$vm2.open('ModalInfoTeleconsulatant');
            await this.getStatusHistories({});
        },
        async getStatusHistories(filters) {
            filters.user = this.infoTeleconsultant.user.id;
            filters.DateType = this.duree;
            if (this.sellerdata)
                filters.seller = this.sellerdata._id || this.sellerdata;

            if (this.productdata)
                filters.product = this.productdata._id || this.productdata;

            if (this.upsel) filters.upsel = this.upsel;

            if (this.formData.startDate && this.formData.endDate) {
                filters.startDate = this.formData.startDate;
                filters.endDate = this.formData.endDate;
            }

            this.infoTeleconsultant.loading = true;
            const res = await this.$server.search('statusHistories', filters);
            this.infoTeleconsultant.loading = false;
            if (res.content.results) {
                this.infoTeleconsultant.dataOrders = res.content.results;
                this.paginate.total = res.content.total;
                this.paginate.lastpage = res.content.last_page;
                this.paginate.per_page = res.content.per_page;
                this.paginate.currentpage = res.content.current_page;
                for (let i in this.infoTeleconsultant.dataOrders) {
                    this.infoTeleconsultant.dataOrders[
                        i
                    ].order_id = this.infoTeleconsultant.dataOrders[i].order.id;
                }
            } else {
                this.infoTeleconsultant.dataOrders = [];
                this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
            }
        },
        async paginatation(direction) {
            var page = 0;
            if (direction == 'next') {
                page = ++this.paginate.currentpage;
            } else {
                page = --this.paginate.currentpage;
            }
            const filters = {
                page: page,
                limit: 10,
            };
            this.getStatusHistories(filters);
        },
        async getwharhouseId() {
            await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
                this.idWharhouse = res;
            });
        },
        async getSellers() {
            if ( this.idWharhouse && this.currentUser && this.currentUser.role && this.currentUser.role.name && 
                this.currentUser.role.name != 'Seller' && this.currentUser.type != 'Seller') {
                const res = await this.$server.search('users', {
                    type: 'Seller',
                    countries: this.idWharhouse.country,
                    limit: 10,
                });

                if (res && res.content.results) this.sellers = res.content.results;
                else this.sellers = [];
            } else this.sellers = [];
        },
        getUsersDebance: _.debounce(async function (name, type) {
            try {
                if (this.idWharhouse && this.idWharhouse.country) {
                    if (this.currentUser.type != 'Seller') {
                        
                        let filter = {
                            limit: 10,
                            type: type,
                            warhouse: this.idWharhouse.country, 
                            search: name
                        };
                        
                        if (type == "TeleConsultant" && this.currentUser.type === 'CallcenterManager' && this.currentUser.teleConsultants) {
                            filter.ids = this.currentUser.teleConsultants;
                        }
                        
                        const res = await this.$server.find("users", filter);
                        const results = res.content.results || [];
                        
                        if (type == 'Seller') this.sellers = results;
                        else this.TabTeleConsultant = results;
                        
                    } else {
                        if (type == 'Seller') this.sellers = [];
                        else this.TabTeleConsultant = [];
                    }
                }
            } catch (error) {
                console.error("Error fetching users:", error);
                this.sellers = [];
                this.teleConsultants = [];
            }
        }, 500),
        getProducts: _.debounce(async function (name) {
            const filter = {
                seller: this.sellerSelected,
                warhouse: this.idWharhouse._id,
                search: name,
            };

            if (this.sellerSelected)
                await this.$store
                    .dispatch('wharhouse/searchProducts', filter)
                    .then(res => {
                        this.products = res;
                    });
        }, 500),
        async CheckSellerProducts(seller = null, model) {
            if (model && model == 'seller') {
                if (seller && seller._id) {
                    this.sellerSelected = seller._id;
                    this.sellerdata = seller;
                    this.products = [];
                    const res = await this.$server.search('products', {
                        'details.warehouse': this.idWharhouse._id,
                        seller: seller._id,
                        limit: 10,
                    });

                    if (res.content.results) {
                        this.products = res.content.results;
                    } else this.products = [];
                } else {
                    this.sellerSelected = null;
                    this.products = [];
                    this.sellerdata = null;
                }
            } else {
                if (seller && seller._id) this.productdata = seller;
                else this.productdata = null;
            }
        },
        getColor(name) {
            if (name == 'Confirmed') return '#73d641';
            else if (name == 'Delivered') return '#1d410b';
            else if (name == 'Reprogram') return '#317873';
            else if (name == 'Interested') return '#1e90ff';
            else if (name == 'Pending Unreached') return '#d617d3';
            else if (name == 'Cancelled') return '#e60451';
            else if (name == 'Cancelled validated') return 'rgb(238, 9, 9)';
            else if (name == 'ToRemind') return '#af7603';
            else return '#5134d3';
        },
        DataParse(data) {
            if (typeof data !== 'undefined') {
                return JSON.parse(data);
            }
            return '';
        },
        getBgColor() {
            var colors = [
                'gray-400',
                'red-500',
                'yellow-500',
                'green-600',
                'orange-600',
                'pink-600',
            ];

            return colors[Math.floor(Math.random() * colors.length)];
        },
        async getUser() {
            const res = await this.$server.me('users');
            if (res.content) this.currentUser = res.content;
            else this.currentUser = {};

            if (
                this.currentUser.type === 'TeleConsultant' ||
                this.currentUser.type === 'CancelledOrder'
            )
                this.teleconsultantId = this.currentUser._id;
        },
        nameToInitials(fullName) {
            if (typeof fullName !== 'undefined' && fullName) {
                const namesArray = fullName.trim().split(' ');
                if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`;
                else
                    return `${namesArray[0].charAt(0)}${namesArray[
                        namesArray.length - 1
                    ].charAt(0)}`;
            } else return fullName;
        },
        getTotalorderUser(data) {
            let count = 0;
            for (let i in data) {
                count += data[i].count;
            }
            return count;
        },
        getTotalorderConfAndCancUser(data) {
            let count = 0;
            for (let i in data) {
                if (data[i].name == 'Confirmed' || data[i].name == 'Cancelled') {
                    count += data[i].count;
                }
            }
            return count;
        },
        getPercentege(
            name = null,
            countStatus,
            total,
            call = null,
            confirmed = null,
        ) {
            if (name && name == 'Unreached') total = call;
            if (name && confirmed && name == 'Delivered') total = confirmed;
            return total ? Math.round((countStatus * 100) / total) : 0;
        },
        emptyCount() {
            this.countOrder = 0;
            this.countOrderConf = 0;
            this.countOrderCan = 0;
            this.countOrderUnr = 0;
            this.countOrderToRem = 0;
            this.countOrderPendingUnr = 0;
            this.countOrderDelivred = 0;
            this.countOrderReprogram = 0;
            this.countOrderInterested = 0;
        },
        ChangeTypeDate: async function (event) {
            this.duree = event.target.value;
            switch (event.target.value) {
                case 'Today':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            _id: this.teleconsultantId,
                            IntervaleDate: 'Today',
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Today',
                        });
                    }
                    break;

                case 'Yesterday':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Yesterday',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Yesterday',
                        });
                    }
                    break;

                case 'This Month':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'This Month',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'This Month',
                        });
                    }
                    break;

                case 'Last Month':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Last Month',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Last Month',
                        });
                    }
                    break;

                case 'This Year':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'This Year',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'This Year',
                        });
                    }

                    break;

                case 'Last Year':
                    this.TeleConsultantTab = [];
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Last Year',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Last Year',
                        });
                    }
                    break;

                case 'Two Date':
                    this.TeleConsultantTab = [];
                    await this.getTotalStatusPerTeleconsultantBetweenTwoDate();
                    break;

                default:
                    this.TeleConsultantTab = [];
                    this.duree = 'Today';
                    this.formData.startDate = '';
                    this.formData.endDate = '';
                    if (this.teleconsultantId) {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Today',
                            _id: this.teleconsultantId,
                        });
                    } else {
                        await this.getTotalOrdersPerTeleConsultant({
                            IntervaleDate: 'Today',
                        });
                    }
            }
        },
        getTotal() {
            for (let i in this.TeleConsultantTab) {
                this.countOrder += this.getTotalorderUser(
                    this.TeleConsultantTab[i].status,
                );
                // this.countOrder += this.TeleConsultantTab[i].count;
                for (let j in this.TeleConsultantTab[i].status) {
                    if (this.TeleConsultantTab[i].status[j].name == 'Confirmed') {
                        this.countOrderConf += this.TeleConsultantTab[i].status[j].count;
                    }
                    if (this.TeleConsultantTab[i].status[j].name == 'Cancelled') {
                        this.countOrderCan += this.TeleConsultantTab[i].status[j].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'Unreached') {
                        this.countOrderUnr += this.TeleConsultantTab[i].status[j].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'Pending Unreached') {
                        this.countOrderPendingUnr += this.TeleConsultantTab[i].status[
                            j
                        ].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'ToRemind') {
                        this.countOrderToRem += this.TeleConsultantTab[i].status[j].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'Delivered') {
                        this.countOrderDelivred += this.TeleConsultantTab[i].status[
                            j
                        ].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'Reprogram') {
                        this.countOrderReprogram += this.TeleConsultantTab[i].status[
                            j
                        ].count;
                    }

                    if (this.TeleConsultantTab[i].status[j].name == 'Interested') {
                        this.countOrderInterested += this.TeleConsultantTab[i].status[
                            j
                        ].count;
                    }
                }
            }
            this.countOrderCancAndConf =
                this.countOrderConf +
                this.countOrderCan +
                this.countOrderPendingUnr +
                this.countOrderToRem;
        },
        async downloadAnalytics(name = null) {
            if (name) {
                var nameTable = 'Analytics';

                var htmls = '';
                var uri = 'data:application/vnd.ms-excel;base64,';
                var template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
                var base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                };

                var format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };

                let table = document.getElementById('p-table');

                this.dataExcel.loading = true;
                this.dataExcel.data = [];
                table = '';

                let filtersP = {
                    user: this.infoTeleconsultant.user.id,
                    DateType: this.duree,
                };
                if (this.sellerdata)
                    filtersP.seller = this.sellerdata._id || this.sellerdata;
                if (this.productdata)
                    filtersP.product = this.productdata._id || this.productdata;
                if (this.upsel) filtersP.upsel = this.upsel;

                if (this.formData.startDate && this.formData.endDate) {
                    filtersP.startDate = this.formData.startDate;
                    filtersP.endDate = this.formData.endDate;
                }

                var itemsCounts = 100;
                filtersP.limit = itemsCounts;
                filtersP.page = 1;
                // filtersP['orderObjet.feesShipp']=-1;
                var count = Math.ceil(this.paginate.total / itemsCounts);
                var close = false;

                for (var i = 0; i < count; i++) {
                    if (close) return;
                    //this.countDown(this.timer);
                    const resAllshipp = await this.$server.search(
                        'statusHistories',
                        filtersP,
                    );

                    //return false
                    if (resAllshipp.content.results) {
                        this.timer += resAllshipp.content.results.length;
                        filtersP.page++;
                        this.dataExcel.data.push(...resAllshipp.content.results);
                    } else close = true;

                    if (close) {
                        this.timer = 0;
                        this.dataExcel.loading = false;
                        alert(
                            'An error occurred, please reload the page and try again !!',
                            'error',
                        );
                    }
                }

                // const resAllshipp = await this.$server.search("shippings",filtersP);
                if (this.dataExcel.data.length > 0) {
                    this.timer = 0;
                    this.dataExcel.loading = false;
                    table = `
            <table style="width: 100%;border-collapse: separate;text-indent: 0;border-spacing: 2px;">
                <thead>
                    <tr>
                        <th style=" background-color: #19706a; font-weight: bold; border: 2px solid #4e504a;color: #fff; " > OrderID </th> 
                        <th style=" background-color: #19706a; font-weight: bold; border: 2px solid #4e504a;color: #fff; "  > Date </th> 
                        <th style=" background-color: #19706a; font-weight: bold; border: 2px solid #4e504a;color: #fff; "  >  TIME SPENT </th> 
                        <th style=" background-color: #19706a; font-weight: bold; border: 2px solid #4e504a;color: #fff; " > CHANGE TO </th>
                        <th style=" background-color: #19706a; font-weight: bold; border: 2px solid #4e504a;color: #fff; " > COMMENT </th>
                    </tr>
                </thead>
            <tbody>`;

                    if (this.dataExcel.data.length == 0) {
                        table += `<tr><th class="border p-3 bg-gray-100" colspan="7">${this.$t(
                            'no_record_found',
                        )}</th></tr>`;
                    }

                    for (const exp of this.dataExcel.data) {
                        table += `
              <tr>
                  <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${exp.order.id
                            }</td>
                  <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${this.$moment(
                                exp.date,
                            ).format('yyyy-MM-DD')}</td>
                  <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${exp.timeConsumed
                            }</td>
                  <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${exp.status.name
                            }</td>
                  <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${exp.comment ||
                            ''}</td>
              </tr>`;
                    }

                    table += `</tbody> </table>`;
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(table, 'text/html');
                    table = doc.body;
                } else this.dataExcel.loading = false;

                htmls = table.outerHTML;
                var ctx = {
                    worksheet: nameTable,
                    table: htmls,
                };

                var link = document.createElement('a');
                link.download = nameTable + '.xls';
                link.href = uri + base64(format(template, ctx));
                link.click();
            } else {
                var arr =
                    typeof this.TeleConsultantTab !== 'object'
                        ? JSON.parse(this.TeleConsultantTab)
                        : this.TeleConsultantTab;
                for (let i in arr) {
                    arr[i].Email = arr[i].email;
                    arr[i].TotalOrdersTraits =
                        arr[i].status[0].count + arr[i].status[1].count;
                    arr[i].TotalCalls =
                        arr[i].status[0].count +
                        arr[i].status[1].count +
                        arr[i].status[2].count +
                        arr[i].status[3].count;
                    arr[i].Confirmed = arr[i].status[0].count;
                    arr[i].Cancelled = arr[i].status[1].count;
                    arr[i].Unreached = arr[i].status[2].count;
                    arr[i].ToRemind = arr[i].status[3].count;
                }
                for (let i in arr) {
                    delete arr[i].email;
                    delete arr[i].status;
                    delete arr[i]._id;
                    delete arr[i].count;
                }
                var str =
                    `${Object.keys(arr[0])
                        .map(value => `"${value}"`)
                        .join(',')}` + '\r\n';
                var csvContent = arr.reduce((st, next) => {
                    st +=
                        `${Object.values(next)
                            .map(value => `"${value}"`)
                            .join(',')}` + '\r\n';
                    return st;
                }, str);
                var element = document.createElement('a');
                element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
                element.target = '_blank';
                element.download = 'exportCallcenters.csv';
                element.click();

                if (this.teleconsultantId) {
                    await this.getTotalOrdersPerTeleConsultant({
                        IntervaleDate: this.duree,
                        _id: this.teleconsultantId,
                    });
                } else {
                    await this.getTotalOrdersPerTeleConsultant({
                        IntervaleDate: this.duree,
                    });
                }
            }
        },
        setSelected(teleconsultant) {
            if (teleconsultant) {
                this.teleconsultantId = teleconsultant._id;
            } else this.teleconsultantId = null;
        },
        async getUsers() {
            if (this.currentUser.type !== 'TeleConsultant') {
                try {
                const filters = {
                    type: 'TeleConsultant',
                    countries: await this.warhouseSelected,
                };

                if (this.currentUser.type === 'CallcenterManager' && this.currentUser.teleConsultants) {
                    filters.ids = this.currentUser.teleConsultants;
                }

                const res = await this.$server.search('users', filters);

                this.TabTeleConsultant = res.content.results ? ['All', ...res.content.results] : [];
                
                } catch (error) {
                    console.error("Error fetching users:", error);
                    this.TabTeleConsultant = [];
                }
            }
        },
        async getTotalOrdersPerTeleConsultant(filters) {
            this.loading = true;
            if (this.sellerdata)
                filters.seller = this.sellerdata._id || this.sellerdata;
            if (this.productdata)
                filters.product = this.productdata._id || this.productdata;
            if (this.upsel) filters.upsel = this.upsel;
            if (this.teleconsultantId) filters._id = this.teleconsultantId;
            filters['country'] = await this.warhouseSelected;
            filters['IntervaleDate'] = this.duree;

            const res = await this.$server.getTotalOrdersPerTeleConsultant(
                'analytics',
                filters,
            );
            this.loading = false;

            if (res.content.content) {
                this.TeleConsultantTab = res.content.content;

                for (let i in this.TeleConsultantTab) {
                    let userData = { fullName: 'System' };
                    if (this.TeleConsultantTab[i].user != 'System') {
                        const getUser = await this.getUserById(
                            this.TeleConsultantTab[i].user,
                        );

                        userData = {
                            fullName: getUser.fullName || getUser.email,
                            type: getUser.type,
                        };
                    }

                    this.TeleConsultantTab[i].userData = JSON.stringify(userData);
                }
            } else this.TeleConsultantTab = [];
            this.emptyCount();
            await this.getTotal();
        },
        async getUserById(id) {
            const editData = await this.$server.get('users', { id: id });
            return editData.content;
        },
        async getTotalStatusPerTeleconsultant(filters) {
            this.loading = true;
            this.TeleConsultantTab = [];
            filters['country'] = await this.warhouseSelected;
            if (this.sellerdata)
                filters.seller = this.sellerdata._id || this.sellerdata;
            if (this.productdata)
                filters.product = this.productdata._id || this.productdata;
            if (this.upsel) filters.upsel = this.upsel;
            if (this.teleconsultantId) filters._id = this.teleconsultantId;
            const res = await this.$server.getTotalOrdersPerTeleConsultant(
                'analytics',
                filters,
            );
            this.loading = false;

            if (res.content.content) {
                this.TeleConsultantTab = res.content.content;
                for (let i in this.TeleConsultantTab) {
                    let userData = { fullName: 'System' };
                    if (this.TeleConsultantTab[i].user != 'System') {
                        const getUser = await this.getUserById(
                            this.TeleConsultantTab[i].user,
                        );
                        userData = {
                            fullName: getUser.fullName || getUser.email,
                            type: getUser.type,
                        };
                    }

                    this.TeleConsultantTab[i].userData = JSON.stringify(userData);
                }
            } else this.TeleConsultantTab = [];

            this.emptyCount();
            await this.getTotal();
        },
        async changeData() {
            this.duree = '';
            this.TabTeleConsultant = [];
        },
        async getTotalStatusPerTeleconsultantBetweenTwoDate() {
            let filters = {
                country: await this.warhouseSelected,
                IntervaleDate: this.duree,
            };
            if (this.teleconsultantId) filters._id = this.teleconsultantId;
            if (this.sellerdata)
                filters.seller = this.sellerdata._id || this.sellerdata;
            if (this.productdata)
                filters.product = this.productdata._id || this.productdata;
            if (this.upsel) filters.upsel = this.upsel;

            if (this.formData.startDate && this.formData.endDate) {
                filters.startDate = this.formData.startDate;
                filters.endDate = this.formData.endDate;
                this.duree = 'Two Date';
                this.loading = true;
                this.TeleConsultantTab = [];
                const res = await this.$server.getTotalStatusPerTeleconsultantBetweenTwoDate(
                    'analytics',
                    filters,
                );
                this.loading = false;
                if (res.content.length > 0) {
                    this.TeleConsultantTab = res.content;
                    for (let i in this.TeleConsultantTab) {
                        let userData = { fullName: 'System' };
                        if (this.TeleConsultantTab[i].user != 'System') {
                            const getUser = await this.getUserById(
                                this.TeleConsultantTab[i].user,
                            );

                            userData = {
                                fullName: getUser.fullName || getUser.email,
                                type: getUser.type,
                            };
                        }

                        this.TeleConsultantTab[i].userData = JSON.stringify(userData);
                    }
                } else this.TeleConsultantTab = [];
                this.emptyCount();
                await this.getTotal();
            } else {
                if (this.duree == 'Two Date') this.duree = 'Today';

                await this.getTotalOrdersPerTeleConsultant(filters);
            }
        },
        async getOrdersX() {
            this.duree = 'Two Date';
            this.TeleConsultantTab = [];
        },
    },
};
</script>

<style scoped>
.card {
    position: relative;
    margin-bottom: 1.5rem;
    width: 100%;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #cdcdcd00;
    border: 1px solid #bcbcbd;
    background-clip: border-box;
    box-shadow: 0 25px 50px rgb(67 69 75 / 23%);
}

.text-xs {
    font-size: 0.6rem;
}

.mt-0\.5 {
    margin-top: 0.125rem;
}

.fz-12 {
    font-size: 12px;
    vertical-align: top;
}

.filter-tel {
    border: 1px solid #dcdee0;
    padding: 20px;
    box-shadow: 0 13px 40px rgb(198 197 202);
}

.img-call {
    display: inline-block;
    width: 14px;
}

.card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin: 0;
    padding: 1rem 1.5rem;
    position: relative;
}

.d-flex {
    display: -ms-flexbox !important;
    display: flex !important;
}

.card-footer {
    border-top: 1px solid #c1c0c5;
    color: #6e7687;
    line-height: 21px;
}

.card-footer span {
    font-size: 12px;
    font-weight: 600;
}

.card-footer,
.card-bottom {
    padding: 0.2rem 1rem;
    background: none;
}

.text-success {
    color: #21c44c !important;
}

.float-right {
    float: right !important;
}

.text-danger {
    color: #f5334f !important;
}

.text-dark {
    color: #182d49 !important;
}

.font-weight-bold {
    font-weight: 700 !important;
}

.display-6 {
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 1.1;
}

.text-muted {
    color: #92969a !important;
}

.fs-13 {
    font-size: 13px !important;
}

.ml-auto,
.mx-auto {
    margin-left: auto !important;
}

.feature .icon {
    border-radius: 3px;
}

.bg-primary {
    background: #564ec1 !important;
}

.fa-stack {
    position: relative;
    display: inline-block;
    width: 2em;
    height: 2em;
    line-height: 2em;
    vertical-align: middle;
    padding: 8px;
}

.fa-2x {
    font-size: 2em;
}

.page-main:after {
    background: #564ec1;
}

.page-main:after {
    content: '';
    height: 280px;
    position: absolute;
    z-index: -1;
    width: 100%;
    top: 0;
    box-shadow: 0 5px 20px rgb(0 0 0 / 20%);
    overflow: hidden;
}

.border-t-b-r {
    border: 1px solid black;
    border-left: none;
}

.image-fit {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.border-t-b-l {
    border: 1px solid black;
    border-right: none;
}

.border-t-b {
    border: 1px solid black;
    border-left: none;
    border-right: none;
}

.teleconsultant .v-select {
    border: 2px solid #edf2f7;
}

table {
    border-collapse: separate;
    border-spacing: 0 7px;
}

.btn-circle {
    border-radius: 100%;
    width: 40px;
    height: 40px;
    padding: 5px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    font-size: 0.875rem;
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.table {
    width: 100%;
    color: #212529;
}

.custom-table thead tr,
.custom-table thead th {
    border-top: none;
    border-bottom: none !important;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    font-size: 12px;
}

.table th,
.table td {
    padding: 0.75rem;
}

.custom-table tbody tr:not(.spacer) {
    border-radius: 7px;
    overflow: hidden;
    -webkit-transition: 0.3s all ease;
    -o-transition: 0.3s all ease;
    transition: 0.3s all ease;
}

.custom-table tbody tr.spacer td {
    padding: 0 !important;
    height: 10px;
    border-radius: 0 !important;
    background: transparent !important;
}

.custom-table tbody tr th:last-child,
.custom-table tbody tr td:last-child {
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
}

.custom-table tbody tr th:first-child,
.custom-table tbody tr td:first-child {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
}

.custom-table tbody tr th,
.custom-table tbody tr td {
    background: #f1f0f000;
}

.custom-table tbody th,
.custom-table tbody td {
    padding-bottom: 0px;
    padding-top: 1px;
    font-weight: 600;
}

.table th,
.table td {
    padding: 0.75rem;
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 83px;
    height: 40px;
    margin-right: auto;
}

.lds-ellipsis div {
    position: absolute;
    top: 16px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #19a69d;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}
</style>
<!--  -->
